import { Map } from 'immutable';

export const CoreConnectProvider = Map({
  S3: 'S3',
  GCS: 'Google Cloud Storage',
  ADLS2: 'Azure Data Lake Storage Gen2',
});

export default CoreConnectProvider;
